import { render, staticRenderFns } from "./TypeScoringContainer.vue?vue&type=template&id=ce5bf812&"
import script from "./TypeScoringContainer.vue?vue&type=script&lang=js&"
export * from "./TypeScoringContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports